// extracted by mini-css-extract-plugin
export var component = "HeaderLogo-module--component--Z0TlT";
export var link = "HeaderLogo-module--link--ZMpgO";